<template>
	<v-overlay :value="loading">
		<v-progress-circular indeterminate size="64" />
	</v-overlay>
</template>


<script>
// ***********************************************************************************
// ** loading a tutta pagina con overlay e spin
// TODO: introdurre un leggero ritardo nell'attivazione, così da non farlo apparire per le chiamate molto brevi
// ***********************************************************************************
export default {
	name: 'LoadingComponent',
	props: {
		// 
		value: {
			type: String,
			default: () => {return ''}
		},
		loading: {
			type: Boolean,
			default: () => {return false}
		} 
	}
}
</script>